export class FormElementError {
    required: boolean = false;
    invalid: boolean = false;
    equalsZeroError: boolean = false;
    bigPriceError: boolean = false;
    message: string;
    maxlength:boolean=false;
    // ovde ubaciti sve nove koji bi se pravili

    reset() {
        this.required = false;
        this.invalid = false;
        this.equalsZeroError = false;
        this.bigPriceError = false;
        this.message = undefined;
        this.maxlength=false;

    }
}
